import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import MyPage from './views/MyPage.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: '로그인',
      component: Login
    },
    {
      path: '/logout',
      name: '로그아웃',
      component: Login
    },
    {
      path: '/myPage',
      name: '마이페이지',
      component: MyPage
    },
    {
      path: '/crop',
      name: '이미지크롭',
      component: () => import('./views/ImageCrop.vue')
    },
    {
      path: '/main',
      name: '메인뷰(탑메뉴)',
      component: () => import('./views/Main.vue'),
      children:
      [
        {
          path: 'home',
          name: 'home',
          component: () => import('./views/home/Home.vue')
        },
        {
          path: 'customer',
          name: '고객사 관리',
          component: () => import('./views/base-data/Company.vue')
        },
        {
          path: 'customerSearch',
          name: '고객사 검색',
          component: () => import('./views/base-data/CompanySearch.vue')
        },
        {
          path: 'position',
          name: '포지션 관리',
          component: () => import('./views/management/Position.vue')
        },
        {
          path: 'positionSearch',
          name: '포지션 검색',
          component: () => import('./views/management/PositionSearch.vue')
        },
        {
          path: 'applicant',
          name: '후보자 관리',
          component: () => import('./views/management/Applicant.vue')
        },
        {
          path: 'applicantSearch',
          name: '후보자 검색',
          component: () => import('./views/management/ApplicantSearch.vue')
        },
        {
          path: 'positionResult',
          name: '합격자 목록',
          component: () => import('./views/management/PositionResult.vue')
        },
        {
          path: 'paymentMag',
          name: '채권관리',
          component: () => import('./views/management/PaymentMag.vue')
        },
        {
          path: 'consultantResult',
          name: '컨설턴트별 합격자',
          component: () => import('./views/management/GroupByConsultantResult.vue')
        },
        {
          path: 'comapnyResult',
          name: '고객사별 합격자',
          component: () => import('./views/management/GroupByCompanyResult.vue')
        },
        {
          path: 'notification',
          name: '게시판',
          component: () => import('./views/management/Board.vue')
        },
        {
          path: 'divisionInfo',
          name: '부서정보',
          component: () => import('./views/base-data/Division.vue')
        },
        {
          path: 'employeeInfo',
          name: '사용자',
          component: () => import('./views/base-data/Employee.vue')
        },
        {
          path: 'baseCode',
          name: '공통코드',
          component: () => import('./views/system/BaseCode.vue')
        },
        {
          path: 'menuPermission',
          name: '메뉴권한',
          component: () => import('./views/system/MenuPermission.vue')
        }

      ]
    }
  ]
})
